import React, { Component } from 'react'
import { PageContainerLayout, PageHeaderLayout } from '../../../layouts'
import { NavLink } from 'react-router-dom'
import * as ROUTING_PATHS from '../../../../routing/Paths'
import { SourceWizardForm } from '../../containers'
import { Session } from '../../../../state/utils/session'

class SourceCreatorPage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      session: new Session()
    }

    this.renderHeaderPaths = this.renderHeaderPaths.bind(this)
  }

  renderHeaderPaths () {
    return (
            <>
                <li>
                    <NavLink className="link-effect"
                             to={ROUTING_PATHS.CLIENT_DASHBOARD_SOURCES_PATH.replace(':client_id', this.state.session.getClientSession())}>
                        Sources
                    </NavLink>
                </li>
                <li>New Source</li>
            </>
    )
  }

  render () {
    return (
            <>

                <PageContainerLayout clientSidebar={true} showNavbarClientOptions={true}>
                    <PageHeaderLayout
                        title={'New Source'}
                        subTitle={'Create a new source'}
                        paths={this.renderHeaderPaths}
                    />
                    <SourceWizardForm/>
                </PageContainerLayout>
            </>
    )
  }
}

export { SourceCreatorPage }
